import { toast } from "sonner";

import Select from "@/components/shared/select";
import { Release } from "@/v2/entities/release/Release.model";
import { useSimulator } from "@/v2/features/simulator/context/SimulatorWrapper";

import { FieldGroup } from "./FieldGroup";

type ArticleLinksMode = "never" | "on_request" | "always";

const options: { label: string; value: ArticleLinksMode }[] = [
  { label: "Never", value: "never" },
  { label: "Only when the user asks", value: "on_request" },
  { label: "Always", value: "always" },
];

// "Always" is includeLink, which wins over articleLinksOnRequest in the AI prompt.
const toMode = (
  release: Pick<Release, "includeLink" | "articleLinksOnRequest"> | null
): ArticleLinksMode => {
  if (release?.includeLink) return "always";
  if (release?.articleLinksOnRequest) return "on_request";
  return "never";
};

export function ArticleLinksField() {
  const { currentRelease, updateRelease } = useSimulator();

  const handleChange = (value: string) => {
    if (!currentRelease?.id) {
      toast.error("Something went wrong, please try again");
      return;
    }

    updateRelease(String(currentRelease.id), {
      simulatorId: currentRelease.simulatorId,
      includeLink: value === "always",
      articleLinksOnRequest: value === "on_request",
    });
  };

  return (
    <FieldGroup
      label={"Article Links"}
      description={
        "Choose when the AI adds links to the help center articles it used. Changes will be relevant from the next published release."
      }
    >
      <Select
        options={options}
        value={toMode(currentRelease)}
        onChange={handleChange}
      />
    </FieldGroup>
  );
}
